import { html } from "@utils/tailwind";

export const Type = {
  H1: html.h1`text-2xl text-neutral-700 font-semibold`,
  H2: html.h2`text-xl text-neutral-700`,
  H3: html.h3`text-lg text-neutral-700 font-medium`,
  H4: html.h4`text-primary-500 font-semibold uppercase tracking-wider`,
  P: html.p`text-neutral-600 max-w-prose`,
  Small: html.small`text-neutral-500 text-sm`,
};
